import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn } from '@angular/router';
import { map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { AccountCompanyService } from '../services/account-company.service';
import { CurrentCompanyService } from '../services/current-company.service';

/**
 * Ensures an accounting company context is open when entering Accounts.
 * Uses Solvix auth only — no separate company-login exchange.
 */
export const companySelectedGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  const auth = inject(AuthService);
  const companyService = inject(AccountCompanyService);
  const currentCompanyService = inject(CurrentCompanyService);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (!auth.isLoggedIn()) {
    return true;
  }

  if (companyService.isCompanyOpen()) {
    return true;
  }

  return currentCompanyService.ensureAccountingCompanyOpen().pipe(
    map(() => true),
  );
};
